import makeStyles from '@material-ui/core/styles/makeStyles';
import { ERebrandingColors } from 'helpers/constants';

const styles = makeStyles((theme) => ({
  '@global': {
    'body, #wrapper-content, #main-footer > p': {
      backgroundColor: '#f9fafb !important',
    },
  },
  root: {
    display: 'flex',
    marginBottom: '1.5rem',
    paddingBottom: '1.5rem',
    position: 'relative',
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    '& > div:first-of-type': {
      flexGrow: 1,
      display: 'flex',
      alignItens: 'center',
    },
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  title: {
    fontWeight: 400,
    fontSize: '2rem',
    lineHeight: '115%',
    color: ERebrandingColors.MAIN,
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.6rem',
    },
  },
  extraContent: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    padding: '0 10px',
  },
  button: {
    textTransform: 'none',
    color: ERebrandingColors.MAIN,
    borderColor: ERebrandingColors.LIGHT,
    fontWeight: 600,
    fontFamily: 'inherit',
    [theme.breakpoints.down('xs')]: {
      marginTop: 16,
    },
  },
  back: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    marginRight: '1.5rem',
    color: theme.palette.grey[500],
    '& > span': {
      marginRight: '0.25rem',
    },
  },
}));

export default styles;
